import { SingleFilterChip } from "@components/common/faro-table/faro-table-filter/single-filter-chip";
import { useProjectMarkupsFilterLists } from "@pages/project-details/project-markups/project-markups-filters/project-markups-filter-list";
import { ProjectMarkupsTableHeaders } from "@pages/project-details/project-markups/project-markups-table-utils";
import { TableType } from "@utils/track-event/track-event-list";

/** Show filters and apply them for project markup Attachment */
export function ProjectMarkupsAttachmentFilter(): JSX.Element {
  const allFilters = useProjectMarkupsFilterLists();

  return (
    <SingleFilterChip
      filteredColumn={ProjectMarkupsTableHeaders.attachments}
      label={"Has linked attachments"}
      item={allFilters.Attachments ?? {}}
      tableType={TableType.projectMarkups}
    />
  );
}
